import React from "react";

import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

import { ReactComponent as IconError18 } from "../../icons/icon/18/a-icon-error-18.svg";

const FormControlFeedback = ({ children }) => (
  <Form.Control.Feedback type="invalid" className="d-flex align-items-center typo-body2">
    <IconError18 className="text-indication mr-6" />
    {children}
  </Form.Control.Feedback>
);

FormControlFeedback.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormControlFeedback;
